import { render, staticRenderFns } from "./treeCate.vue?vue&type=template&id=d04ab0ec&scoped=true"
import script from "./treeCate.vue?vue&type=script&lang=js"
export * from "./treeCate.vue?vue&type=script&lang=js"
import style0 from "./treeCate.vue?vue&type=style&index=0&id=d04ab0ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04ab0ec",
  null
  
)

export default component.exports